import React from 'react';
import StepHeader from '~/components/shared/Stepper/components/StepHeader';
import { useCardOfferSelectors } from '~/store/selectors/cardOffer.selector';

const OwnershipHeader = () => {
  const { ownersDataIsFetched } = useCardOfferSelectors();

  const title = 'OnboardingOffer.Ownership';
  const description = ownersDataIsFetched
    ? 'OnboardingOffer.OwnershipFetchedOwnersDescription'
    : 'OnboardingOffer.OwnershipDescription';

  return <StepHeader title={title} description={description} />;
};

export default OwnershipHeader;
